


























import { Component, Vue } from 'vue-property-decorator';
import { AppUserLoginModel } from '@/services/api/nswag/stapiclient_generated';
import { stAuthenticationApi } from '@/services/st-api';
import { resetGlobalData } from '@/store/global-data-helper';
import StInput2 from '@/components/basic/StInput2.vue';
import axios from 'axios';
import {notifyError} from '@/utlitities/notifications';

@Component({
  components: {
    StInput2,
  },
})
export default class Login extends Vue {
  private loginModel: AppUserLoginModel = AppUserLoginModel.fromJS({});
  private loading: boolean = false;
  passwordShown = false;
  st2Link = '';
  fromHp: boolean = false;

  created() {
    this.fromHp = !!this.$route.params.fromhp;
  }

  get passwordType() {
    return this.passwordShown ? 'text' : 'password';
  }

  mounted() {
    stAuthenticationApi.logout();
    resetGlobalData();
  }

  togglePasswordType() {
    this.passwordShown = !this.passwordShown;
  }

  async submit() {
    this.loading = true;
    try {
      if (this.fromHp) {
        let preLoginCheck = await stAuthenticationApi.prelogin(this.loginModel.email as string);

        if (preLoginCheck.st2AccountName) {
          let loginInfo: any = {};
          loginInfo.AccountName = preLoginCheck.st2AccountName;
          loginInfo.Username = this.loginModel.email;
          loginInfo.Password = this.loginModel.password;
          loginInfo.Issue = true;

          const uninterceptedAxiosInstance = axios.create();

          try {
            let result = await uninterceptedAxiosInstance.post('https://www.spiketime.de/api/login', loginInfo, {withCredentials: false});
            //Vue.$plausible.trackEvent('loginSpikeTimeV2');
            window.location.href = `https://${preLoginCheck.st2AccountName}.spiketime.de/app/Account/SpecialLogin?c=${result.data.ch}`;
          } catch(err)
          {
            notifyError("Unbekannter Benutzer oder falsches Passwort");
          }
        } else {
          await stAuthenticationApi.login(this.loginModel);
          //Vue.$plausible.trackEvent('login');
          await this.$router.push('/');
        }
      } else {
        await stAuthenticationApi.login(this.loginModel);
        //Vue.$plausible.trackEvent('login');
        await this.$router.push('/');
      }
    } finally {
      this.loading = false;
    }
  }
}
